// extracted by mini-css-extract-plugin
export var bodySections = "_7g-8";
export var gray = "_7g-7";
export var green = "_7g-4";
export var iconContainer = "_7g-9";
export var iconWidgetContainer = "_7g-1";
export var phoneIcon = "_7g-2";
export var red = "_7g-5";
export var statusDot = "_7g-3";
export var widgetContainer = "_7g-0";
export var yellow = "_7g-6";